/**
 * 🍦 SPLASH SCREEN
 * Beautiful mango gradient loading screen
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Splash.module.css';

export function SplashPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/menu', { replace: true });
    }, 8000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {/* Frosty Mango Logo */}
        <div className={styles.logoContainer}>
          <img 
            src="/fmlogo.png" 
            alt="Frosty Mango" 
            className={styles.logo}
          />
        </div>

        {/* Manny Mascot */}
        <div className={styles.mascotContainer}>
          <img 
            src="/manny-small.png" 
            alt="Manny" 
            className={styles.mascot}
          />
        </div>

        {/* Loading indicator */}
        <div className={styles.loader}>
          <div className={styles.loaderDot}></div>
          <div className={styles.loaderDot}></div>
          <div className={styles.loaderDot}></div>
        </div>

        {/* Tagline at Bottom */}
        <p className={styles.tagline}>Enjoy Your Stadium Experience</p>
      </div>
    </div>
  );
}
